export default __webpack_public_path__ + "static/media/BrainBreak cards48.8bc5e1db.png";